/* src/app/components/date-range-picker/date-range-picker.component.css */
.form-group.hidden {
  width: 0;
  margin: 0;
  border: none;
  padding: 0;
}
.custom-day {
  text-align: center;
  padding: 0.185rem 0.25rem;
  display: inline-block;
  height: 2rem;
  width: 2rem;
}
.custom-day.focused {
  background-color: var(--border);
}
.custom-day.range,
.custom-day:hover {
  background-color: rgb(2, 117, 216);
  color: white;
}
.custom-day.faded {
  background-color: rgba(2, 117, 216, 0.5);
}
.calendar-contrl {
  background-image: url(/assets/img/calendar.png);
  width: 2.75rem;
  background-repeat: no-repeat;
  background-size: 23px;
  background-position: center;
}
/*# sourceMappingURL=date-range-picker.component.css.map */
